import { Component, Vue } from 'vue-property-decorator'
import { appendScript, appendLink } from '@/utils/script'
import Vuex from 'vuex'
import QuestionVenus from '../components/question-venus'
import Player from '@/apps/h5/components/player'
import { getWeikeInfo } from '@/apps/h5/model/api'

@Component({ components: { QuestionVenus, Player }})
export default class WeikeInfo extends Vue {
    public weikeInfo: any = {}

    // getWeikeInfo
    public async getWeikeInfo() {
        const options = {}
        const header = {}
        const { data, success }: any = await getWeikeInfo(options, header)

        if (success) {
            this.weikeInfo = data
        }
    }
    // mounted
    public mounted() {
        this.getWeikeInfo()
    }
}